export default {
    mapper: {
        relations: {
            belongsTo: {
                product: {
                    foreignKey: 'product_id',
                    localField: 'product',
                },
                user: {
                    foreignKey: 'user_id',
                    localField: 'user',
                },
            },
        },
    },
};
